// extracted by mini-css-extract-plugin
export default {"icon":"AllowMultiplesModifierOptions_icon__XLDdt"};